module.exports = __webpack_public_path__ + "static/media/rain-day.d8924f1a.jpeg";